export const ADD_TRX_LOYALTY = 'ADD_TRX_LOYALTY';
export const ADD_LOCAL_TRX_LOYALTY = 'ADD_LOCAL_TRX_LOYALTY';
export const SYNC_TRX_LOYALTY = 'SYNC_TRX_LOYALTY';
export const SET_NEW_LOCAL_TRX = 'SET_NEW_LOCAL_TRX';
export const SET_TRX_CUSTOMER = 'SET_TRX_CUSTOMER';
export const SET_LOYALTY_STATES = 'SET_LOYALTY_STATES';
